import React from 'react'

function Spacer(props) {
    const {width}=props
  return (
    <div style={{width:width?width:"20%"}}></div>
  )
}

export default Spacer